import React, { PropTypes, Component } from 'react'
import styles from '../styles'
import CellDiv from './cellDiv'

export default class TextCell extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    width: PropTypes.string.isRequired,
  };

  constructor (props) {
    super(props)
  }

  shouldComponentUpdate (nextProps) {
    return (
      this.props.text !== nextProps.text ||
      this.props.width !== nextProps.width
    )
  }

  render () {
    return (
      <CellDiv width={this.props.width} className={styles.textCell}>
        {this.props.text}
      </CellDiv>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataTable/dataCell/textCell.jsx